export default "__VITE_PUBLIC_ASSET__491d02be__"